import { DocumentClient } from 'aws-sdk/clients/dynamodb';

import DynamoMonitoringDatasource from '../../monitoring/db/datasource';
import DateUtils from '../../util/date';
import { MONITORING_TABLE_SCHEMA } from '../../monitoring/db/schema';

export const USER_INFO_SORT_KEY = 'userInfo';

export const completeGettingStartedTaskUpdate = (
  userId: string,
  completedOn: Date,
  taskName: string
): DocumentClient.Update => {
  return {
    Key: {
      hashKey: DynamoMonitoringDatasource.encodeHashKey({ userId }),
      sortKey: USER_INFO_SORT_KEY,
    },
    TableName: MONITORING_TABLE_SCHEMA.TableName,
    UpdateExpression: `set gettingStarted.completedTasks.${taskName} = :created`,
    ConditionExpression: `attribute_not_exists(gettingStarted.completedTasks.${taskName})`,
    ExpressionAttributeValues: {
      ':created': DateUtils.getUnixTimestamp(completedOn),
    },
  };
};
